<template>
<div class="lookCount-wrap">
    <div class="lookCount">
        <div class="nav clearfix">
            <router-link to='/mine'>
                <img class="navBack pull-left" src="../../../static/images/shootShop/back.png" alt="">
            </router-link>
            <h2 class="navTitle pull-left">看铺次数</h2>
            <router-link to='/lookCountDetails'>
                <p>查看明细</p>
            </router-link>
        </div>
        <div class="lookCount-main">
            <div class="lookCount-box">
                <div>
                    <h2>今日剩余看铺次数：<span>{{numIndex}}</span></h2>
                    <h5>做任务可增加看铺次数</h5>
                </div>
                <dl class="clearfix">
                    <dt class="fl">
                        <h3>每日签到</h3>
                        <p>每日首次登录，+5次看铺次数</p>
                    </dt>
                    <dd class="fr grayBtn">已完成</dd>
                </dl>
                <dl class="clearfix">
                    <dt class="fl">
                        <h3>开通会员</h3>
                        <p>开通会员，每日额外+25次看铺次数</p>
                    </dt>
                    <dd class="fr" @click="goBuymember()">去完成</dd>
                </dl>
                <dl class="clearfix">
                    <dt class="fl">
                        <h3>一键分享</h3>
                        <p>每日首次分享，+2次看铺次数</p>
                    </dt>
                    <dd class="fr" @click="isShowPopup = true">去完成</dd>
                </dl>
                <dl class="clearfix">
                    <dt class="fl">
                        <h3>一键纠错</h3>
                        <p>纠错通过后，额外+5次看铺次数</p>
                    </dt>
                    <!-- <dd class="fr">已完成</dd> -->
                </dl>
            </div>
        </div>
        <!-- 城市切换弹窗 -->
        <div class="popupWrap" v-if="isShowPopup">
            <div class="popupBox">
                <h2>温馨提示</h2>
                <p>该功能只限租铺宝APP使用</p>
                <div>
                    <span class="span1" @click="isShowPopup = false">取消</span>
                    <span class="span2"><a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.example.dc.zupubao">去下载</a></span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'seekShop',
    data () {
        return {
            isShowPopup: false,
            numIndex: ""
        }
    },
    computed:{

    },
    updated(){

    },
    methods:{
        goBuymember(){
            this.$router.push({path:"/buymember",query:{lookCount:1}});
        },
        // 获取查看次数
        userData(){
            let url =  this.changeData() + '/shop/shopCheckedRecords'
            axios(url,{
                method: 'post',
                params:
                {
                    cityId: sessionStorage.cityId,
                    shopId: "0",
                    type: "0",
                    roof: "0"
                },
            }).then(data => {
                // console.log(data);
                if(data.data.code == 101){
                    // 用户查看次数
                    this.numIndex = data.data.count;
                }
            }).catch(err => {
                console.log(err)
            });
        }
    },
    mounted() {
        this.userData();
    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.fr{
    float: right;
}
.fl{

    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color:#fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#fff;
}
/*内容部分*/
.lookCount-wrap{
    width: 7.5rem;
    margin: 0 auto;
}
.lookCount{
    width: 7.5rem;
    margin: 0 auto;
    /*background: #fff;*/
    padding-top: .88rem;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 99;
    a{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
    .navBack{
        width: 0.2rem;
        height: 0.36rem;
        margin-top: 0.26rem;
        float: left;
    }
    .navTitle{
        height: .88rem;
        width: 5rem;
        line-height: .88rem;
        font-size: 0.36rem;
        color: #3c3c3c;
        text-align: center;
        float: left;
        margin-left: .5rem;
    }
    p{
        position: absolute;
        right: .3rem;
        top: .22rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        color: #666;
        font-size: .28rem;
    }
}

.lookCount-main{
    width: 6.9rem;
    padding: 0 .3rem;
    color: #363636;
    .lookCount-box{
        margin-top: .3rem;
        width: 6.3rem;
        background: #fff;
        border-radius: .2rem;
        padding: 0 .3rem .1rem;
        div{
            height: 1.55rem;
            h2{
                font-size: .36rem;
                color: #363636;
                font-weight: 500;
                padding-top: .36rem;
                span{
                    color: #ff7700;
                    font-size: .44rem;
                    font-weight: 600;
                    position: relative;
                    top: .02rem;
                }
            }
            h5{
                color: #9f9fa8;
                font-size: .24rem;
            }
        }
        dl{
            height: 1.3rem;
            border-top: 1px solid #e7e7e7;
            dt{
                h3{
                    color: #363636;
                    font-size: .3rem;
                    margin-top: .28rem;
                }
                p{
                    color: #9f9fa8;
                    font-size: .24rem;
                    line-height: .3rem;
                }
            }
            dd{
                color: #363636;
                font-size: .26rem;
                width: 1.34rem;
                background: #2f7af7;
                border-radius: .27rem;
                color: #fff;
                text-align: center;
                padding: .02rem 0;
                margin-top: .38rem;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
            }
            .grayBtn{
                background: #f5f6f8;
                color: #363636;
            }
        }
    }
}
/*弹窗*/
.popupWrap{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 100000000;
    .popupBox{
        width: 6rem;
        height: 3.2rem;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 32%;
        margin-left: -3rem;
        border-radius: 6px;
        overflow: hidden;
        h2{
            color: #444;
            text-align: center;
            line-height: 1.2rem;
            margin-top: .2rem;
            font-size: .4rem;
        }
        p{
            color: #444;
            text-align: center;
            font-size: .3rem;
            color: #444;
        }
        div{
            width: 100%;
            height: .88rem;
            position: absolute;
            left: 0;
            bottom: 0;
            span{
                display: inline-block;
                width: 50%;
                line-height: .88rem;
                float: left;
                text-align: center;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                a{
                    color: #fff;
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                }
            }
            .span1{
                background: #eee;
            }
            .span2{
                background: #64ABFF;
                color: #fff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/lookCount.vue